import React from 'react'

import Modal from 'react-modal'

import { func, node } from 'prop-types'

import ShareModalHeader from './Components/ShareModalHeader'

function ShareModal({ closeModal: handleCloseModal, content }) {
  return (
    <Modal
      isOpen
      shouldCloseOnOverlayClick
      onRequestClose={handleCloseModal}
      contentLabel="Share Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--share',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="share-modal">
        <ShareModalHeader closeModal={handleCloseModal} />
        <div className="share-modal__content">
          {content}
        </div>
      </div>
    </Modal>
  )
}

ShareModal.propTypes = {
  closeModal: func.isRequired,
  content: node.isRequired,
}

export default ShareModal
